<template>
  <v-chip label small color="grey" text-color="white" class="mr-2">
    {{ title }}
  </v-chip>
</template>

<script>
export default {
  props: ["value"],
  computed: {
    title() {
      switch (this.value) {
        case 1:
          return "1 місяць";
        case 3:
          return "3 місяці";
        case 4:
          return "4 місяці";
        case 6:
          return "6 місяців";
        case 9:
          return "9 місяців";
        case 10:
          return "10 місяців";
        case 12:
          return "12 місяців";
        case 14:
          return "14 місяців";
        case 24:
          return "24 місяців";
        case 26:
          return "26 місяців";
        case 30:
          return "30 місяців";
        default:
          return "Не вказано";
      }
    },
  },
};
</script>
